import { render } from "./MainSubModules.vue?vue&type=template&id=22f2d0dc&scoped=true"
import script from "./MainSubModules.vue?vue&type=script&lang=js"
export * from "./MainSubModules.vue?vue&type=script&lang=js"

import "./MainSubModules.vue?vue&type=style&index=0&id=22f2d0dc&scoped=true&lang=css"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f2d0dc"]])

export default __exports__